import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { formatBackendDateToMonthDayLong } from 'modules/core/lib/dates'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  date: string
  minutes: number
}

const DateWithValue = ({ date, minutes }: Props) => {
  return (
    <Box paddingLeft="s24" flexDirection="row" width="full" justifyContent="spaceBetween">
      <Text color="grey1000" size="200">
        {formatBackendDateToMonthDayLong(date)}
      </Text>
      <MinutesToText color="grey1000" value={minutes || 0} size="200" />
    </Box>
  )
}

export default DateWithValue
